import { render, staticRenderFns } from "./LinkInfo.vue?vue&type=template&id=6fe2074e&scoped=true&"
import script from "./LinkInfo.vue?vue&type=script&lang=js&"
export * from "./LinkInfo.vue?vue&type=script&lang=js&"
import style0 from "./LinkInfo.vue?vue&type=style&index=0&id=6fe2074e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe2074e",
  null
  
)

export default component.exports